import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import { formatarData } from '../../lib/formatos'

export default function HistoricoImportacoes() {
  const importacoes = useLiveQuery(
    () => banco.importacoes.filter((i) => i.apagado_em === null).reverse().sortBy('criado_em'),
    [],
  )
  return (
    <section className="p-4 space-y-3">
      <h2 className="text-lg font-bold text-slate-800">Histórico de importações</h2>
      {importacoes?.length === 0 && <p className="text-sm text-slate-500">Nenhuma importação ainda.</p>}
      <ul className="space-y-2">
        {importacoes?.map((imp) => (
          <li key={imp.id} className="bg-white rounded-xl shadow-sm p-3">
            <span className="block text-sm font-medium text-slate-800">
              {formatarData(new Date(imp.criado_em))} — {imp.status}
            </span>
            <span className="block text-xs text-slate-500">
              {imp.total_inseridos} novos, {imp.total_atualizados} atualizados, {imp.total_pulados} pulados
            </span>
            {imp.erros.length > 0 && (
              <details className="mt-1">
                <summary className="text-xs text-red-600 cursor-pointer">
                  {imp.erros.length} linha(s) com problema
                </summary>
                {imp.erros.map((e) => (
                  <p key={`${e.linha}-${e.motivo}`} className="text-xs text-red-500">
                    Linha {e.linha}: {e.motivo}
                  </p>
                ))}
              </details>
            )}
          </li>
        ))}
      </ul>
    </section>
  )
}
